<script lang="ts">
  // components
  import CartProduct from "@retailer/svelte/Cart/Page/DistributorSection/CartProduct.svelte";
  import RecentlyRemoved from "./RecentlyRemoved.svelte";
  import PickupOrDeliveryBanner from "../PickupOrDelivery/PickupOrDeliveryBanner.svelte";
  import FulfillmentMethodOptions from "@retailer/svelte/Shared/FulfillmentMethodOptions.svelte";
  import RequestItemsContainer from "@retailer/svelte/Cart/Page/DistributorSection/RequestItemsContainer.svelte";

  // stores
  import RecentlyRemovedProductStore from "@retailer/stores/RecentlyRemovedProductStore";
  import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
  import { CraftAlertsStore } from "@shared/svelte/Components/Craft/CraftAlertsWrapper.svelte";

  // services
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import {
    isOHLQOrder,
    updateOrderFulfillmentMethod,
  } from "@retailer/services/order_fulfillment_service";

  // types
  import type { CartOrderType } from "@shared/types/Cart";

  export let cartService: any; // Angular Service
  export let order: CartOrderType;
  export let callbacks: any;
  export let showLoading: boolean;
  export let customPricingMode;
  export let warehouse: any;
  export let products;
  export let currentLocation: { id: number; name: string };

  let showFulfillmentMethodsDrawer: boolean = false;

  const productGroupTestId = (warehouseId: number) => {
    const id = warehouseId ? warehouseId : "delivery";
    return id;
  };

  let inFulfillmentEnhancementsRollout = stagedRolloutCheck(
    "marketplace__cart_page_fulfillment_enhancements",
  );
  const OHLQOrderPaymentMethodsEnabled = stagedRolloutCheck(
    "marketplace__ohlq_order_payment_methods",
  );
  const distributorId = order.distributor.id;
  const showOrderFulfillmentMethodBanner =
    OHLQOrderPaymentMethodsEnabled &&
    isOHLQOrder(distributorId) &&
    order.distributor.account_number;

  const openFulfillmentMethodsDrawer = () => {
    showFulfillmentMethodsDrawer = !showFulfillmentMethodsDrawer;
  };

  const triggerAlert = (event: CustomEvent) => {
    const warehouse = event.detail;

    CraftAlertsStore.add({
      message:
        warehouse.location_code === ""
          ? `You are now ordering for delivery for ${$CurrentRetailerStore.name}`
          : `You are now ordering for pickup at ${warehouse.name} for ${$CurrentRetailerStore.name}`,
      variant: "success",
    });
  };

  const saveFulfillmentMethodSelection = async (event: CustomEvent) => {
    const warehouse = event.detail;
    await updateOrderFulfillmentMethod(distributorId, products, warehouse.location_code);
    triggerAlert(event);
    window["stateService"].reload();
  };

  $: hasRecentlyRemovedProduct =
    $RecentlyRemovedProductStore?.orderId === order.id &&
    $RecentlyRemovedProductStore?.warehouseId === warehouse.id;
</script>

{#if products.every(p => p.requested_item)}
  <RequestItemsContainer
    {order}
    {cartService}
    {callbacks}
    {showLoading}
    {customPricingMode}
    {products}
  />
{:else}
  <div
    id="order-body-{productGroupTestId(warehouse.id)}"
    data-testid={productGroupTestId(warehouse.id) + "-product-group"}
    class="craft"
  >
    {#if showOrderFulfillmentMethodBanner}
      <div class="fizz-stack-16" />
      <PickupOrDeliveryBanner
        {currentLocation}
        showFulfillmentMethodButton={true}
        on:openDrawer={openFulfillmentMethodsDrawer}
      />
      <FulfillmentMethodOptions
        bind:open={showFulfillmentMethodsDrawer}
        distributor={order.distributor}
        selectedStockSiteId={order.products[0].warehouse_location_code}
        useCustomSave={true}
        on:saveSelection={saveFulfillmentMethodSelection}
      />
    {/if}
    {#each products.filter(p => !p.requested_item) as product, pindex (product.id)}
      {#if hasRecentlyRemovedProduct && pindex === $RecentlyRemovedProductStore?.index}
        <RecentlyRemoved product={$RecentlyRemovedProductStore} />
      {/if}
      <div
        class="cart__item fizz-surface"
        class:fizz-border-top={pindex === 0 && !inFulfillmentEnhancementsRollout}
        data-product-id={product.id}
        data-testid="product-{product.id}"
      >
        <CartProduct
          Cart={cartService}
          {product}
          {order}
          {callbacks}
          {pindex}
          {showLoading}
          bind:customPricingMode
        />
      </div>
    {/each}
  </div>
{/if}
